import {useFeaturesState} from '../../../../../../../Organisms/Features'

export const useFeatureSlotManagementForRmcOrderIntakeEnabled = createFeatureFlagHook(
  'enableSlotManagementForRmcOrderIntake'
)

export const useFeatureSlotManagementForRmcOrderManagementEnabled = createFeatureFlagHook(
  'enableSlotManagementForRmcOrderManagement'
)

export const useFeatureShowOutOfOperationalHoursSlotsForRmcOrderIntake = createFeatureFlagHook(
  'showOutOfOperationalHoursSlotsForRmcOrderIntake'
)
export const useFeatureShowOutOfOperationalHoursSlotsForRmcOrderManagement = createFeatureFlagHook(
  'showOutOfOperationalHoursSlotsForRmcOrderManagement'
)

function createFeatureFlagHook(featureName: string) {
  return function () {
    const {getFeature} = useFeaturesState()
    return getFeature(featureName)
  }
}
